import moment from 'moment'
import * as codeMap from '@/config/code'

const timeFormat = 'HH:mm'
const dateFormat = 'YYYY-MM-DD'

export const toTime = (val, fm) =>
  val ? moment(val).format(fm || timeFormat) : ''

export const toDate = (val, fm) =>
  val ? moment(val).format(fm || dateFormat) : ''

export const toDateTime = (val, fm) =>
  val ? moment(val).format(fm || `${dateFormat} ${timeFormat}`) : ''

export const toText = (val, codeMapKey, defaultValue = '-') => {
  const data = codeMap[codeMapKey]
  if (Array.isArray(data)) {
    const hit = data.find(i => i.value === val)
    return hit ? hit.label : defaultValue
  }
  if (data && val in data) {
    return data[val]
  }
  console.warn(`${val}, ${codeMapKey} 无对应的 value`)
  return defaultValue
}

export const htmlToText = html => {
  return html.replace(/(<\/?[a-z]+?(?:\s+?[^>].*?)?>)|(&nbsp;)/g, '')
}



// WEBPACK FOOTER //
// ./src/utils/filter.js